export default __webpack_public_path__ + "05aed783bb843046ed38f7b46475ab00.png";